import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import "../../pages/BaseLayout.css";

export default function BaseLayout({ children }) {
  return (
    <div className="layout-wrapper">
      <Sidebar />

      <div className="layout-content">
        <Topbar />

        <div className="layout-page">
          {children}
        </div>
      </div>
    </div>
  );
} 